module.exports = __webpack_public_path__ + "img/sbsy.ecddcafd.gif";